/* eslint-disable linebreak-style */

export const messages = {
  ro: {
    common: {
      yes: 'Da',
      no: 'Nu',
      loading: 'Loading ...',
      language: 'Limba',
      romanian: 'Romana',
      english: 'Engleza',
      bulgarian: 'Bulgara'
    },
    app: {
      loadingData: 'Se incarca datele, va rugam sa asteptati...'
    },
    sidebar: {
      home: 'Home',
      products: 'Produse',
      account: 'Contul meu',
      contact: 'Contact',
      settings: 'Setari',
      signOut: 'Deconectare',
      signIn: 'Autentificare',
      bnrTitle: 'CURS BNR'
    },
    signIn: {
      title: 'Autentificare',
      email: 'Email',
      password: 'Parola',
      submit: 'Conectare',
      forgotPassword: 'Am uitat parola?',
      requiredField: 'aceasta rubrica este obligatorie',
      invalidEmailForReset: 'Va rog completati adresa de email folosita la crearea contului!',
      resetSuccess: 'Email-ul cu link-ul de resetare a fost trimis cu succes.',
      resetError: 'Eroare : nu am putut trimite e-mailul cu linkul de resetare a parolei.({error})',
      loading: 'loading....'
    },
    signUp: {
      requiredField: 'is required',
      title: 'Create new account',
      subtitle: 'Use your email to create new account',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email address',
      password: 'Password',
      policyPrefix: 'I have read the',
      policyLink: 'Terms and Conditions',
      submit: 'Sign up now',
      haveAccount: 'Have an account?',
      signIn: 'Sign in'
    },
    account: {
      noAccess: 'Nu aveti drepturi de acces pentru modulul: Contul meu!'
    },
    order: {
      noProductTypeSet: 'Nici un tip de produs nu este setat',
      prefillClientPlaceholder: 'CLIENT DE COMPLETAT',
      addLineTitle: 'Adauga reper nou'
    },
    orderHeader: {
      title: 'COMANDA {product} {status}',
      statusDefault: 'NETRANSMISA',
      statusSent: 'TRANSMISA',
      pendingFirstSave: 'Numarul si data se stabilesc dupa prima salvare',
      sentSubheader: 'Numar: {id} din: {date} / data transmiterii: {updatedAt}',
      updatedSubheader: 'Numar: {id} din: {date} / ultima modificare: {updatedAt}',
      clientFinalTooltip: 'Clientul final al distribuitorului.',
      clientFinalLabel: 'Client final',
      clientFinalLocked: 'Clientul final nu mai poate fi schimbat dupa adaugarea primului reper.',
      selectClientFinal: 'Selecteaza client final',
      clientFinalDetails: 'Detalii client final',
      clientFinalDetailsValue: 'Ruta: {ruta} | Oras: {oras} | Adresa: {adresa} | Email: {email} | Telefon: {telefon} | Discount {product}: {discount}%',
      measurementsAddressTooltip: 'Adresa la care se vor efectua masuratorile de catre Larexir Decor.',
      measurementsAddressLabel: 'Adresa masuratoare (incl. numar telefon)',
      measurementsTypeTooltip: 'Tipul de produs pentru care se fac masuratorile.',
      productTypeLabel: 'Tip produs',
      expoAddressTooltip: 'Adresa la care se va livra expozorul solicitat.',
      expoAddressLabel: 'Adresa livrare (incl. numar telefon)',
      observationsLabel: 'Observatii'
    },
    orderFooter: {
      saveInProgress: 'O operatiune de salvare/trimitere este deja in curs.',
      hasChangesTitle: 'Comanda are modificari',
      hasChangesMessage: 'Sunteti sigur ca doriti sa abandonati aceste modificari?',
      cancelAbandon: 'Operatia de abandon a fost anulata.',
      selectFinalClient: 'Selectati clientul final din lista!',
      missingClient: 'Nu ati completat clientul!',
      missingDeliveryAddress: 'Nu ati completat adresa de livrare!',
      saveSuccess: 'Salvare cu succes',
      saveError: 'Eroare : nu am putut salva comanda.({error})',
      sendSuccess: 'Trimitere cu succes',
      sendError: 'Eroare : nu am putut trimite comanda.({error})',
      sendConfirmTitle: 'Confirmare trimitere comanda',
      sendConfirmMessage: 'Odata transmisa, o comanda nu mai poate suferi modificari si va fi considerata o comanda ferma. Sunteti sigur ca doriti sa trimiteti aceasta comanda?',
      sendCanceled: 'Operatia de transmitere a fost anulata.',
      send: 'Trimite',
      save: 'Salvare',
      cancel: 'Abandon'
    },
    orderLines: {
      add: 'Adauga',
      edit: 'Modifica',
      delete: 'Sterge',
      update: 'Actualizare',
      cancel: 'Abandon',
      save: 'Salveaza',
      columnId: 'ID reper',
      columnNo: 'Nr.',
      item: 'reper',
      items: 'repere',
      emptyRecord: 'Nu exista inregistrari',
      editOperationAlert: 'Nu ati selectat nici un reper!',
      deleteOperationAlert: 'Nu ati selectat nici un reper!',
      saveButton: 'Salvare',
      cancelButton: 'Abandon',
      confirmDelete: 'Sunteti sigur ca doriti stergerea reperului?',
      cancelEdit: 'Sunteti sigur ca doriti sa abandonati modificarile facute ?',
      pagerCurrent: '{0} din {1} pagini',
      pagerFirst: 'prima pagina',
      pagerLast: 'ultima pagina',
      pagerNext: 'urmatoarea pagina',
      pagerPrevious: 'pagina anterioara',
      pagerTotal: '({0} inregistrari)',
      addTooltip: 'Adauga reper noua',
      editTooltip: 'Modifica reperul selectat',
      deleteTooltip: 'Sterge reperul selectat',
      transmittedReadOnly: 'Comanda transmisa - nu se pot face modificari',
      noClientBeforeAdd: 'Nu se pot adauga repere pana nu se completeaza Clientul!',
      addTitle: 'Adauga reper nou',
      editTitle: 'Modifica reper',
      selectLineWarning: 'Va rog selectati un reper',
      deleteConfirmTitle: 'Confirmare stergere',
      deleteConfirmMessage: 'Sigur doriti stergerea reperului?',
      deleteCanceled: 'Operatia de stergere a fost abandonata.',
      addSuccess: 'Reper adaugat cu succes',
      editSuccess: 'Reper modificat cu succes',
      deleteSuccess: 'Reper sters cu succes'
    },
    orderLineEdit: {
      validationError: 'Datele introduse nu respecta regulile de validare. Nu se poate salva inregistrarea.',
      save: 'Salvare',
      cancel: 'Abandon',
      clientPriceEditableNote: '*)rubrica pret client este editabila'
    },
    orderLineForm: {
      typeBlind: 'Tip roleta',
      typePleatedBlind: 'Tip jaluzea plisata',
      typeVenetian: 'Tip jaluzea',
      typeRoller: 'Tip rulou',
      typeGarageDoor: 'Tip usa garaj',
      material: 'Material',
      code: 'Cod',
      code1: 'Cod 1',
      code2: 'Cod 2',
      color: 'Culoare',
      colorSlats: 'Culoare lamele',
      colorCassette: 'Culoare caseta',
      meshType: 'Tip plasa',
      partialMesh: 'Contine plasa partiala',
      width: 'Latime',
      widthRail: 'Latime(garnisa)',
      widthFabric: 'Latime PANZA',
      widthFinal: 'Latime FINALA',
      height: 'Inaltime',
      heightFabric: 'Inaltime PANZA',
      heightFinal: 'Inaltime FINALA',
      openingType: 'Tip desc.',
      actionType: 'Tip actionare',
      quota: 'Cota',
      quotaFinalGol: 'Cota (finala/gol)',
      action: 'Actionare',
      axis: 'Ax',
      colorComponents: 'Culoare componente',
      colorComponentsLegacy: 'Culoare comp. vechi *)',
      colorCode: 'Cod culoare',
      colorCode2: 'Cod culoare 2',
      fixingGuideDownFix: 'Fixare (Ghid/DownFix)',
      stickLengthShort: 'Lung. betisor',
      metalClampsShort: 'Cleme met.',
      option1: 'Optional 1',
      option2: 'Optional 2',
      option3: 'Optional 3',
      option4: 'Optional 4',
      optional: 'Optional',
      codeCombination: 'Descriere combinatie coduri(Cod culoare vechi)',
      cordLength: 'Lungime snur',
      consoleType: 'Tip console',
      consoleCount: 'Numar console',
      notes: 'Observatii',
      quantity: 'Cantitate',
      tPrefix: 'T',
      left: 'Stanga',
      right: 'Dreapta',
      small: 'MIC',
      large: 'MARE',
      axis32mm: '32mm',
      cartsPerPiece: 'Carucioare/buc',
      mpPerPiece: 'MP/buc',
      totalMp: 'TOTAL MP',
      catalogPrice: 'Pret catalog',
      commissionerPrice: 'Pret comisionar',
      orderPrice: 'Pret comanda',
      clientPrice: 'Pret client',
      unitMm: 'mm',
      unitCons: 'cons.',
      unitPieces: 'buc',
      unitMp: 'mp',
      unitLei: 'lei',
      openingWarningPrefix: 'Tip deschidere: {value} - {message}',
      openingHint1: 'Ati selectat o actionare prin care lamelele se vor strange in partea cu snurul de actionare (stanga sau dreapta).',
      openingHint2: 'Ati selectat o actionare prin care lamelele se vor strange in partea opusa snurului de actionare (stanga sau dreapta).',
      openingHint3: 'Ati selectat o actionare prin care lamelele se vor strange stanga-dreapta, tip Cortina (jumatate stanga si cealalta jumatate in dreapta).',
      openingHint4: 'Ati selectat o actionare prin care lamelele se vor strange invers tip Cortina (toate pe mijlocul garnisei).',
      openingHintL: 'Doriti sa dati in executie doar lamelele de jaluzele, fara garnisa (trebuie sa introduceti la casuta Lungime numarul de lamele, ex. 23).',
      openingHintDA: 'Doriti sa dati in executie o garnisa cu dubla actionare (snurul de actionare de ambele parti, care actioneaza independent lungimi diferite de garnisa). Cost suplimentar: 40 lei/buc.',
      consoleDefaultWarning: 'Daca nu completati Tipul de console, se vor considera ca fiind console fixe.',
      codeWarningPrefix: 'Mesaj pentru codul:{code}: {message}',
      partialMeshSingleWarning: 'Atentie! Reperele ce contin plase partiale se introduc individual(Cantitate=1), fiind urmate in reperul urmator al comenzii de plasa partiala.',
      partialMeshFollowWarning: 'Atentie! Reperul ce contine plasa partiala trebuie urmat in reperul urmator al comenzii de plasa partiala.',
      priceZeroTooLarge: 'Pret 0 pentru dimensiunile introduse.Dimensiuni prea mari pentru produsul selectat!!',
      jvHeightNote: 'Atentie! Inaltimea trebuie sa cuprinda si grosimea garnisei inclusiv la comenzile care contin doar lamele de material.(Tip desc.: L)',
      jviMinBillableHeight: 'Atentie! INALTIMEA MINIMA FACTURABILA ESTE DE 2000 mm !!!'
    },
    ordersFooter: {
      productsMenu: 'Meniu produse',
      offerPdf: 'Oferta pdf',
      orderPdf: 'Comanda pdf',
      selectOrderWarning: 'Va rog selectati o comanda.'
    },
    ordersTable: {
      add: 'Adauga',
      edit: 'Modifica',
      delete: 'Sterge',
      update: 'Actualizare',
      cancel: 'Abandon',
      save: 'Salveaza',
      item: 'comanda',
      items: 'comenzi',
      emptyRecord: 'Nu exista inregistrari',
      editOperationAlert: 'Nu ati selectat nici o comanda!',
      deleteOperationAlert: 'Nu ati selectat nici o comanda!',
      saveButton: 'Salvare',
      cancelButton: 'Abandon',
      confirmDelete: 'Sunteti sigur ca doriti stergerea comenzii?',
      cancelEdit: 'Sunteti sigur ca doriti sa abandonati modificarile facute ?',
      pagerCurrent: '{0} din {1} pagini',
      pagerFirst: 'prima pagina',
      pagerLast: 'ultima pagina',
      pagerNext: 'urmatoarea pagina',
      pagerPrevious: 'pagina anterioara',
      pagerTotal: '({0} inregistrari)',
      addTooltip: 'Adauga comanda noua',
      editTooltip: 'Modifica comanda selectata',
      deleteTooltip: 'Sterge comanda selectata',
      filterContains: 'Contine',
      filterStartsWith: 'Incepe cu',
      filterEndsWith: 'Se termina cu',
      missingProduct: 'Eroare. Nu am gasit nici un produs selectat!',
      loadOrderDetailError: 'Eroare: nu am putut incarca detaliul comenzii.',
      noOrderSelected: 'Nu ati selectat nici o comanda.',
      confirmDeleteTitle: 'Confirmare stergere',
      confirmDeleteMessage: 'Sunteti sigur ca doriti stergerea comenzii selectate?',
      deleteError: 'Eroare : nu am putut sterge comanda.({error})',
      deleteSuccess: 'Comanda a fost stearsa cu succes.',
      deleteCanceled: 'Operatia de stergere a fost abandonata.',
      deleteOnlyDraftWarning: 'Doar comenzile NETRANSMISE se pot sterge',
      colSelect: 'SEL',
      colOrderNo: 'NR. COMANDA',
      colDate: 'DATA',
      colClient: 'CLIENT',
      colOrderValue: 'VALOARE COMANDA',
      colFinalValue: 'VALOARE CLIENT FINAL',
      colStatus: 'STADIU'
    },
    ordersList: {
      exchangeRateNotice: 'Atentie! Cursul valutar luat in calcul pentru produsele a caror pret este in Euro este cursul BNR+ 1% de la data in care preluam comanda.',
      workScheduleNotice: 'Preluarea comenzilor se face in timpul programului de lucru (Luni-Vineri intre orele 09:00-17:00, exceptie facand sarbatorile legale). Pentru comenzile transmise inafara programului de lucru, data preluarii este urmatoarea zi lucratoare.',
      quoteFluctuationNotice: 'Din acest motiv, va rugam sa luati in calcul eventuala fluctuatie a cursului la momentul ofertarii catre clientul final.'
    },
    productCard: {
      menuPresentation: 'Prezentare',
      menuPrices: 'Preturi',
      menuMeasureInstall: 'Masurare montaj',
      menuVideo: 'Video',
      menuRequestDisplay: 'Solicita expozor',
      loadingOrders: 'Se incarca comenzile...',
      orderProcessError: 'A aparut o eroare la procesarea comenzii.'
    },
    productList: {
      pagination: '1-6 of 20'
    },
    expozor: {
      headerTitle: 'EXPOZOARE (in lucru)',
      selectFirst: 'Selectati mai intai un produs din lista.',
      noCompany: 'Utilizatorul curent nu are firma asociata.',
      noLinesAllowed: 'Tipul de produs selectat nu permite adaugarea de repere.',
      templateBuildError: 'Nu am putut construi o comanda noua pentru produsul selectat.',
      launchOrderError: 'Nu am putut lansa comanda noua. Va rugam incercati din nou.',
      emptySearch: 'Nu exista produse care sa corespunda cautarii.',
      emptyList: 'Nu exista produse disponibile.',
      search: 'Cauta:',
      searchPlaceholder: 'Text de cautat in descrierea expozorului',
      scrollUp: 'Scroll in sus',
      scrollDown: 'Scroll in jos',
      noImage: 'Fara imagine',
      defaultProduct: 'Produs',
      loadingCta: 'Se pregateste...',
      configureOrderCta: 'Configureaza comanda ta **)',
      disclaimer: '*)Pret de catalog orientativ. Poate varia marginal in functie de cursul valutar de la data comenzii.\n**)Produs similar ca tip, culoare, material si optionale. Nu se preiau cotele expozorului.Poate fi total sau partial modificat dupa preluare.'
    },
    video: {
      headerTitle: 'VIDEO (in lucru)',
      groupDefault: 'Grupa',
      sectionDefault: 'General',
      allCategories: 'Toate categoriile',
      clipForProduct: 'Clipuri pentru {product}',
      demoClips: 'Clipuri demonstrative{suffix}',
      selectFromList: 'Selecteaza un clip din lista pentru a porni redarea.',
      noVideosForSelection: 'Nu exista clipuri pentru selectia curenta.',
      clipVideo: 'Clip video',
      emptySelectPrompt: 'Selectati un clip din lista pentru a porni redarea.',
      emptySearch: 'Nu exista clipuri pentru cautarea introdusa.',
      emptyConfigured: 'Nu exista videoclipuri configurate momentan.',
      searchLabel: 'Cauta',
      searchPlaceholder: 'Titlu sau descriere clip',
      boardCategories: 'Categorii',
      boardVideo: 'Video',
      mobileSearchLabel: 'Cauta clip',
      mobileSearchPlaceholder: 'Titlu sau descriere',
      thumbnailAlt: 'Thumbnail video',
      closePlayer: 'Inchide playerul video'
    },
    contact: {
      formTitle: 'FORMULAR CONTACT',
      email: 'Email',
      subject: 'Subiect',
      message: 'Mesaj',
      submit: 'TRIMITE',
      sendError: 'Eroare : mesajul nu a putut fi trimis.({error})',
      sendSuccess: 'Mesaj trimis cu succes.',
      mailSubjectPrefix: 'Mesaj WebStore de la: {email} Subiect: {subject}',
      companyTitle: 'DATE DE CONTACT',
      companyName: 'SC LAREXIR DECOR SRL',
      phoneLabel: 'Telefon: {phone}',
      emailLabel: 'Email: {email}',
      responseHours: 'Raspundem cinci zile pe saptamana, in intervalul 09:00-17:30'
    },
    settings: {
      noAccess: 'Nu aveti drepturi de acces pentru modulul: Setari!',
      resetPasswordTitle: 'Resetare parola acces',
      resetPasswordSubheader: 'Pentru a reseta parola apasati butonul de mai jos. Veti primi un email cu link-ul necesar resetarii parolei. Verificati primirea email-ului si in Spam.',
      resetPasswordButton: 'TRIMITE LINK RESETARE PAROLA',
      resetPasswordSendError: 'Eroare : nu am putut trimite e-mailul cu codul de resetare.({error})',
      resetPasswordSendSuccess: 'Email-ul cu codul de resetare a fost trimis cu succes.'
    },
    resetPassword: {
      pageTitle: 'WebStore Larexir- resetare parola!',
      invalidCode: 'WebStore Larexir- cod resetare invalid!',
      newPasswordTitle: 'Parola noua',
      passwordLabel: 'Parola',
      confirmPasswordLabel: 'Confirmare parola',
      resetCodeLabel: 'Cod resetare',
      submit: 'RESETEAZA',
      saveError: 'Eroare : cod resetare invalid/expirat sau lipsa conexiune.({error})',
      saveSuccess: 'Parola noua a fost setata cu succes.',
      mismatch: 'Rubrica Parola nu este egala cu rubrica Confirmare parola!'
    },
    notFound: {
      title: '404: Pagina pe care incercati sa o accesati nu exista.',
      subtitle: 'Oricare ar fi motivul, pentru a va intoarce in pagina principala a aplicatei, apasati iconita de logo din stanga sus.'
    },
    accountDetails: {
      saveError: 'Eroare : nu am putut salva modificarile.({error})',
      saveSuccess: 'Modificari salvate cu succes.',
      companySubheader: 'Informatiile pot fi editate',
      companyTitle: 'DATE SOCIETATE',
      companyName: 'Denumire firma',
      city: 'Oras',
      county: 'Judet',
      address: 'Adresa',
      phone: 'Telefon',
      bankAccount: 'Cont bancar',
      bank: 'Banca',
      contactPerson: 'Persoana contact',
      save: 'Salvare',
      discountsSubheader: 'Discounturi acordate de Larexir Decor conform intelegerilor contractuale',
      discountsTitle: 'DISCOUNTURI',
      marginSubheader: 'Adaosuri peste pretul de catalog aplicate clientului final',
      marginTitle: 'ADAOSURI'
    },
    accountAddresses: {
      editTitle: 'Editare adresa de livrare',
      addTitle: 'Adaugare adresa de livrare',
      locationName: 'Nume locatie',
      postalCode: 'Cod postal',
      notes: 'Observatii',
      cancel: 'Abandon',
      save: 'Salvare',
      addButton: 'Adauga adresa livrare',
      updateError: 'Eroare : nu am putut salva modificarile.({error})',
      updateSuccess: 'Modificarile la adresa de livrare au fost salvate cu succes.',
      createError: 'Eroare : nu am putut salva adresa de livrare.({error})',
      createSuccess: 'Adresa de livrare a fost salvata cu succes.',
      listTitle: 'ADRESE DE LIVRARE',
      edit: 'Editare',
      delete: 'Sterge',
      confirmDeleteTitle: 'Confirmare stergere',
      confirmDeleteMessage: 'Sunteti sigur ca doriti stergerea acestei adrese de livrare din lista?',
      deleteError: 'Eroare : nu am putut sterge adresa de livrare.({error})',
      deleteSuccess: 'Adresa de livrare a fost stearsa cu succes.',
      deleteCanceled: 'Operatia de stergere a fost abandonata.'
    },
    accountCommissioner: {
      subheader: 'Lista clientilor finali asociati comisionarului.',
      title: 'CLIENTI FINALI COMISIONAR',
      name: 'Denumire',
      city: 'Oras',
      county: 'Judet',
      address: 'Adresa',
      noClients: 'Nu exista clienti asociati acestui comisionar.'
    },
    dashboard: {
      generalInfo: 'INFORMARI GENERALE',
      welcome: 'Bine ati venit in aplicatia WebStore Larexir!',
      signInInfo: 'Pentru conectare folositi butonul : Autentificare din meniul din stanga si introduceti datele de conectare transmise de noi pe e-mail.',
      companyMessages: 'MESAJE PENTRU FIRMA: {name}',
      resetTitle: 'WebStore Larexir- resetare parola!'
    },
    pdf: {
      common: {
        noRows: 'Comanda nu are inregistrari',
        obsPrefix: 'Obs.:',
        total: 'Total: {value} {currency}'
      },
      header: {
        taxCode: 'Cod fiscal',
        tradeRegister: 'Reg. com.',
        address: 'Adresa',
        phone: 'Telefon',
        email: 'Email',
        offerTitle: 'OFERTA {product}',
        orderTitle: 'COMANDA {product}',
        number: 'Numar',
        date: 'Data',
        status: 'Stadiu',
        client: 'Client',
        observations: 'Observatii',
        deliveryAddress: 'Adresa livrare'
      },
      footer: {
        lastUpdate: 'Ultima modificare/transmitere: {date}'
      },
      content: {
        nrCrt: 'Nr. crt',
        tip: 'Tip',
        tipRulou: 'Tip rulou',
        tipRoleta: 'Tip roleta',
        tipJaluzea: 'Tip jaluzea',
        cod: 'Cod',
        material: 'Material',
        lungime: 'Lungime',
        inaltime: 'Inaltime',
        tipDesc: 'Tip desc.',
        cod1: 'Cod 1',
        cod2: 'Cod 2',
        combCoduri: 'Comb. coduri',
        lungimeSnurShort: 'L.snur',
        tipConsole: 'Tip console',
        nrConsole: 'Nr. console',
        optional: 'Optional',
        optional1: 'Optional 1',
        optional2: 'Optional 2',
        optional3: 'Optional 3',
        optional4: 'Optional 4',
        cant: 'Cant.',
        pretLei: 'Pret(lei)',
        pretEuro: 'Pret(euro)',
        lungimePanza: 'Lungime PANZA',
        lungimeFinala: 'Lungime FINALA',
        inaltimePanza: 'Inaltime PANZA',
        inaltimeFinala: 'Inaltime FINALA',
        actionare: 'Actionare',
        actionareShort: 'Act.',
        tipActionare: 'Tip actionare',
        ax: 'Ax',
        culoareComp: 'Culoare comp.',
        culoareLamela: 'Culoare lamela',
        culoareCaseta: 'Culoare caseta',
        culoare: 'Culoare',
        cota: 'Cota',
        fixare: 'Fixare',
        codCuloare: 'Cod culoare',
        codCuloare2: 'Cod culoare 2',
        lungimeBetisorActionare: 'Lungime betisor actionare',
        clemePrindereMetal: 'Cleme prindere metal',
        observatii: 'Observatii'
      }
    },
    reports: {
      common: {
        onlySentOrders: 'Raportul cuprinde doar comenzile transmise.',
        dateStart: 'Data inceput',
        dateEnd: 'Data sfarsit',
        dateFormatPlaceholder: 'dd.mm.yyyy',
        periodRequired: 'Selectati perioada pentru raport.',
        invalidDateFormat: 'Format data invalid. Folositi formatul dd.mm.yyyy.',
        startAfterEnd: 'Data de inceput nu poate fi mai mare decat data de sfarsit.',
        generateError: 'Eroare la generarea raportului: {error}'
      },
      user: {
        cardTitle: 'RAPORT COMENZI',
        pdfTitle: 'Raport comenzi',
        companyPeriod: 'Firma: {name} | Perioada: {start} - {end}',
        button: 'Raport comenzi',
        filePrefix: 'raport-comenzi',
        missingCompany: 'Nu am putut identifica firma utilizatorului.',
        productType: 'Tip produs: {type} ({currency})',
        totalByType: 'Total {type}',
        totalGeneral: 'Total general',
        totalByCurrency: 'Total {currency}',
        columns: {
          productType: 'Tip produs',
          orderId: 'ID comanda',
          date: 'Data',
          client: 'Client',
          orderValue: 'Val. comanda',
          finalValue: 'Val. client final',
          notes: 'Obs'
        }
      },
      commissioner: {
        cardTitle: 'RAPORT COMISIONAR',
        pdfTitle: 'Raport comisionar',
        companyPeriod: 'Comisionar: {name} | Perioada: {start} - {end}',
        productType: 'Tip produs: {type} ({currency})',
        button: 'Raport comisionar',
        filePrefix: 'raport-comisionar',
        noClients: 'Nu exista clienti asociati acestui comisionar.',
        opInfo1: 'Platile cu OP sunt identificate prin cautarea sintagmei OP (ex. OP, O.P., O P) in campul Observatii.',
        opInfo2: 'Aceasta determinare nu este absoluta si necesita verificare suplimentara.',
        totalByType: 'Total {type}',
        totalOpByType: 'Total OP {type}',
        totalGeneral: 'Total general',
        totalByCurrency: 'Total {currency}',
        totalOpByCurrency: 'Total OP {currency}',
        opMark: 'OP',
        columns: {
          productType: 'Tip produs',
          orderId: 'ID comanda',
          date: 'Data',
          client: 'Client',
          catalogValue: 'Val. catalog',
          finalValue: 'Val. client final',
          commissionerValue: 'Val. comisionar',
          difference: 'Diferenta',
          notes: 'Obs',
          op: 'OP'
        }
      }
    }
  },
  en: {
    common: {
      yes: 'Yes',
      no: 'No',
      loading: 'Loading ...',
      language: 'Language',
      romanian: 'Romanian',
      english: 'English',
      bulgarian: 'Bulgarian'
    },
    app: {
      loadingData: 'Loading data, please wait...'
    },
    sidebar: {
      home: 'Home',
      products: 'Products',
      account: 'My account',
      contact: 'Contact',
      settings: 'Settings',
      signOut: 'Sign out',
      signIn: 'Sign in',
      bnrTitle: 'NBR RATE'
    },
    signIn: {
      title: 'Sign in',
      email: 'Email',
      password: 'Password',
      submit: 'Connect',
      forgotPassword: 'Forgot password?',
      requiredField: 'this field is required',
      invalidEmailForReset: 'Please fill in the email used when creating the account!',
      resetSuccess: 'Reset password email was sent successfully.',
      resetError: 'Error: failed to send reset password email. ({error})',
      loading: 'loading....'
    },
    signUp: {
      requiredField: 'is required',
      title: 'Create new account',
      subtitle: 'Use your email to create new account',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email address',
      password: 'Password',
      policyPrefix: 'I have read the',
      policyLink: 'Terms and Conditions',
      submit: 'Sign up now',
      haveAccount: 'Have an account?',
      signIn: 'Sign in'
    },
    account: {
      noAccess: 'You do not have access rights for: My account!'
    },
    order: {
      noProductTypeSet: 'No product type is set',
      prefillClientPlaceholder: 'CLIENT TO COMPLETE',
      addLineTitle: 'Add new line'
    },
    orderHeader: {
      title: 'ORDER {product} {status}',
      statusDefault: 'NOT_SENT',
      statusSent: 'SENT',
      pendingFirstSave: 'Number and date are set after first save',
      sentSubheader: 'Number: {id} from: {date} / sent date: {updatedAt}',
      updatedSubheader: 'Number: {id} from: {date} / last update: {updatedAt}',
      clientFinalTooltip: 'The final customer of the distributor.',
      clientFinalLabel: 'Final customer',
      clientFinalLocked: 'Final customer can no longer be changed after the first line is added.',
      selectClientFinal: 'Select final customer',
      clientFinalDetails: 'Final customer details',
      clientFinalDetailsValue: 'Route: {ruta} | City: {oras} | Address: {adresa} | Email: {email} | Phone: {telefon} | Discount {product}: {discount}%',
      measurementsAddressTooltip: 'Address where measurements will be made by Larexir Decor.',
      measurementsAddressLabel: 'Measurement address (incl. phone number)',
      measurementsTypeTooltip: 'Product type for measurements.',
      productTypeLabel: 'Product type',
      expoAddressTooltip: 'Address where the requested display stand will be delivered.',
      expoAddressLabel: 'Delivery address (incl. phone number)',
      observationsLabel: 'Notes'
    },
    orderFooter: {
      saveInProgress: 'A save/send operation is already in progress.',
      hasChangesTitle: 'Order has changes',
      hasChangesMessage: 'Are you sure you want to discard these changes?',
      cancelAbandon: 'Discard operation was canceled.',
      selectFinalClient: 'Select the final customer from the list!',
      missingClient: 'Final customer is required!',
      missingDeliveryAddress: 'Delivery address is required!',
      saveSuccess: 'Saved successfully',
      saveError: 'Error: failed to save order. ({error})',
      sendSuccess: 'Sent successfully',
      sendError: 'Error: failed to send order. ({error})',
      sendConfirmTitle: 'Confirm order sending',
      sendConfirmMessage: 'Once sent, an order can no longer be changed and becomes final. Are you sure you want to send this order?',
      sendCanceled: 'Send operation was canceled.',
      send: 'Send',
      save: 'Save',
      cancel: 'Cancel'
    },
    orderLines: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      update: 'Update',
      cancel: 'Cancel',
      save: 'Save',
      columnId: 'Line ID',
      columnNo: 'No.',
      item: 'line',
      items: 'lines',
      emptyRecord: 'No records to display',
      editOperationAlert: 'No line selected!',
      deleteOperationAlert: 'No line selected!',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      confirmDelete: 'Are you sure you want to delete the line?',
      cancelEdit: 'Are you sure you want to discard your changes?',
      pagerCurrent: '{0} of {1} pages',
      pagerFirst: 'first page',
      pagerLast: 'last page',
      pagerNext: 'next page',
      pagerPrevious: 'previous page',
      pagerTotal: '({0} records)',
      addTooltip: 'Add new line',
      editTooltip: 'Edit selected line',
      deleteTooltip: 'Delete selected line',
      transmittedReadOnly: 'Order sent - no more edits allowed',
      noClientBeforeAdd: 'Cannot add lines until Final customer is filled in!',
      addTitle: 'Add new line',
      editTitle: 'Edit line',
      selectLineWarning: 'Please select a line',
      deleteConfirmTitle: 'Delete confirmation',
      deleteConfirmMessage: 'Are you sure you want to delete the line?',
      deleteCanceled: 'Delete operation was canceled.',
      addSuccess: 'Line added successfully',
      editSuccess: 'Line updated successfully',
      deleteSuccess: 'Line deleted successfully'
    },
    orderLineEdit: {
      validationError: 'Entered values do not pass validation rules. Record cannot be saved.',
      save: 'Save',
      cancel: 'Cancel',
      clientPriceEditableNote: '*)client price field is editable'
    },
    orderLineForm: {
      typeBlind: 'Blind type',
      typePleatedBlind: 'Pleated blind type',
      typeVenetian: 'Venetian blind type',
      typeRoller: 'Roller type',
      typeGarageDoor: 'Garage door type',
      material: 'Material',
      code: 'Code',
      code1: 'Code 1',
      code2: 'Code 2',
      color: 'Color',
      colorSlats: 'Slat color',
      colorCassette: 'Cassette color',
      meshType: 'Mesh type',
      partialMesh: 'Contains partial mesh',
      width: 'Width',
      widthRail: 'Rail width',
      widthFabric: 'Fabric width',
      widthFinal: 'Final width',
      height: 'Height',
      heightFabric: 'Fabric height',
      heightFinal: 'Final height',
      openingType: 'Open type',
      actionType: 'Control type',
      quota: 'Quota',
      quotaFinalGol: 'Quota (final/opening)',
      action: 'Control',
      axis: 'Axis',
      colorComponents: 'Component color',
      colorComponentsLegacy: 'Legacy component color *)',
      colorCode: 'Color code',
      colorCode2: 'Color code 2',
      fixingGuideDownFix: 'Fixing (Guide/DownFix)',
      stickLengthShort: 'Stick len.',
      metalClampsShort: 'Metal clamps',
      option1: 'Optional 1',
      option2: 'Optional 2',
      option3: 'Optional 3',
      option4: 'Optional 4',
      optional: 'Optional',
      codeCombination: 'Code combination description(old color code)',
      cordLength: 'Cord length',
      consoleType: 'Bracket type',
      consoleCount: 'Bracket count',
      notes: 'Notes',
      quantity: 'Quantity',
      tPrefix: 'T',
      left: 'Left',
      right: 'Right',
      small: 'SMALL',
      large: 'LARGE',
      axis32mm: '32mm',
      cartsPerPiece: 'Runners/pc',
      mpPerPiece: 'SQM/pc',
      totalMp: 'TOTAL SQM',
      catalogPrice: 'Catalog price',
      commissionerPrice: 'Commissioner price',
      orderPrice: 'Order price',
      clientPrice: 'Client price',
      unitMm: 'mm',
      unitCons: 'pcs',
      unitPieces: 'pcs',
      unitMp: 'sqm',
      unitLei: 'ron',
      openingWarningPrefix: 'Opening type: {value} - {message}',
      openingHint1: 'You selected a control where slats gather on the cord side (left or right).',
      openingHint2: 'You selected a control where slats gather opposite to the control cord side (left or right).',
      openingHint3: 'You selected a left-right curtain control (half left and half right).',
      openingHint4: 'You selected an inverse curtain control (all slats gather in the middle).',
      openingHintL: 'You want only blind slats without rail (enter slat count in Length field, e.g. 23).',
      openingHintDA: 'You want a rail with double control (cords on both sides controlling different rail lengths). Extra cost: 40 lei/pc.',
      consoleDefaultWarning: 'If you do not select bracket type, fixed brackets will be used by default.',
      codeWarningPrefix: 'Code message:{code}: {message}',
      partialMeshSingleWarning: 'Warning! Lines with partial mesh are entered one by one (Quantity=1), followed by the matching partial mesh on the next order line.',
      partialMeshFollowWarning: 'Warning! A line containing partial mesh must be followed by the matching partial mesh on the next order line.',
      priceZeroTooLarge: 'Zero price for entered dimensions. Dimensions are too large for selected product.',
      jvHeightNote: 'Warning! Height must include rail thickness, including orders containing only fabric slats. (Open type: L)',
      jviMinBillableHeight: 'Warning! MINIMUM BILLABLE HEIGHT IS 2000 mm !!!'
    },
    ordersFooter: {
      productsMenu: 'Products menu',
      offerPdf: 'Offer pdf',
      orderPdf: 'Order pdf',
      selectOrderWarning: 'Please select an order.'
    },
    ordersTable: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      update: 'Update',
      cancel: 'Cancel',
      save: 'Save',
      item: 'order',
      items: 'orders',
      emptyRecord: 'No records to display',
      editOperationAlert: 'No order selected!',
      deleteOperationAlert: 'No order selected!',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      confirmDelete: 'Are you sure you want to delete the order?',
      cancelEdit: 'Are you sure you want to discard your changes?',
      pagerCurrent: '{0} of {1} pages',
      pagerFirst: 'first page',
      pagerLast: 'last page',
      pagerNext: 'next page',
      pagerPrevious: 'previous page',
      pagerTotal: '({0} records)',
      addTooltip: 'Add new order',
      editTooltip: 'Edit selected order',
      deleteTooltip: 'Delete selected order',
      filterContains: 'Contains',
      filterStartsWith: 'Starts with',
      filterEndsWith: 'Ends with',
      missingProduct: 'Error. No selected product found!',
      loadOrderDetailError: 'Error: failed to load order details.',
      noOrderSelected: 'No order selected.',
      confirmDeleteTitle: 'Delete confirmation',
      confirmDeleteMessage: 'Are you sure you want to delete the selected order?',
      deleteError: 'Error: failed to delete order. ({error})',
      deleteSuccess: 'Order deleted successfully.',
      deleteCanceled: 'Delete operation was canceled.',
      deleteOnlyDraftWarning: 'Only NOT_SENT orders can be deleted',
      colSelect: 'SEL',
      colOrderNo: 'ORDER NO.',
      colDate: 'DATE',
      colClient: 'CLIENT',
      colOrderValue: 'ORDER VALUE',
      colFinalValue: 'FINAL CLIENT VALUE',
      colStatus: 'STATUS'
    },
    ordersList: {
      exchangeRateNotice: 'Warning! Exchange rate used for products priced in Euro is NBR + 1% from the date when the order is processed.',
      workScheduleNotice: 'Orders are processed during working hours (Monday-Friday between 09:00-17:00, except legal holidays). For orders sent outside working hours, processing date is the next business day.',
      quoteFluctuationNotice: 'For this reason, please consider possible exchange rate fluctuation when offering to the final client.'
    },
    productCard: {
      menuPresentation: 'Presentation',
      menuPrices: 'Prices',
      menuMeasureInstall: 'Measurement and install',
      menuVideo: 'Video',
      menuRequestDisplay: 'Request display',
      loadingOrders: 'Loading orders...',
      orderProcessError: 'An error occurred while processing the order.'
    },
    productList: {
      pagination: '1-6 of 20'
    },
    expozor: {
      headerTitle: 'DISPLAYS (work in progress)',
      selectFirst: 'Select a product from the list first.',
      noCompany: 'Current user has no company assigned.',
      noLinesAllowed: 'Selected product type does not allow adding lines.',
      templateBuildError: 'Could not build a new order for selected product.',
      launchOrderError: 'Could not start a new order. Please try again.',
      emptySearch: 'No products match the search.',
      emptyList: 'No products available.',
      search: 'Search:',
      searchPlaceholder: 'Search text in display description',
      scrollUp: 'Scroll up',
      scrollDown: 'Scroll down',
      noImage: 'No image',
      defaultProduct: 'Product',
      loadingCta: 'Preparing...',
      configureOrderCta: 'Configure your order **)',
      disclaimer: '*)Catalog price is indicative. It may vary slightly depending on exchange rate at order date.\n**)Similar product by type, color, material and options. Display dimensions are not copied. It can be fully or partially modified after loading.'
    },
    video: {
      headerTitle: 'VIDEO (work in progress)',
      groupDefault: 'Group',
      sectionDefault: 'General',
      allCategories: 'All categories',
      clipForProduct: 'Clips for {product}',
      demoClips: 'Demo clips{suffix}',
      selectFromList: 'Select a clip from the list to start playback.',
      noVideosForSelection: 'No clips available for current selection.',
      clipVideo: 'Video clip',
      emptySelectPrompt: 'Select a clip from the list to start playback.',
      emptySearch: 'No clips for entered search.',
      emptyConfigured: 'No videos are configured at the moment.',
      searchLabel: 'Search',
      searchPlaceholder: 'Clip title or description',
      boardCategories: 'Categories',
      boardVideo: 'Video',
      mobileSearchLabel: 'Search clip',
      mobileSearchPlaceholder: 'Title or description',
      thumbnailAlt: 'Video thumbnail',
      closePlayer: 'Close video player'
    },
    contact: {
      formTitle: 'CONTACT FORM',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      submit: 'SEND',
      sendError: 'Error: message could not be sent. ({error})',
      sendSuccess: 'Message sent successfully.',
      mailSubjectPrefix: 'WebStore message from: {email} Subject: {subject}',
      companyTitle: 'CONTACT DETAILS',
      companyName: 'SC LAREXIR DECOR SRL',
      phoneLabel: 'Phone: {phone}',
      emailLabel: 'Email: {email}',
      responseHours: 'We respond five days a week, between 09:00-17:30'
    },
    settings: {
      noAccess: 'You do not have access rights for: Settings!',
      resetPasswordTitle: 'Access password reset',
      resetPasswordSubheader: 'To reset password press the button below. You will receive an email with the required reset link. Check Spam as well.',
      resetPasswordButton: 'SEND RESET PASSWORD LINK',
      resetPasswordSendError: 'Error: failed to send reset code email. ({error})',
      resetPasswordSendSuccess: 'Reset code email was sent successfully.'
    },
    resetPassword: {
      pageTitle: 'WebStore Larexir - password reset!',
      invalidCode: 'WebStore Larexir - invalid reset code!',
      newPasswordTitle: 'New password',
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm password',
      resetCodeLabel: 'Reset code',
      submit: 'RESET',
      saveError: 'Error: invalid/expired reset code or no connection. ({error})',
      saveSuccess: 'New password was set successfully.',
      mismatch: 'Password field does not match Confirm password field!'
    },
    notFound: {
      title: '404: The page you are trying to access does not exist.',
      subtitle: 'Whatever the reason, to return to home page click the logo icon from top-left.'
    },
    accountDetails: {
      saveError: 'Error: could not save changes. ({error})',
      saveSuccess: 'Changes saved successfully.',
      companySubheader: 'Information can be edited',
      companyTitle: 'COMPANY DETAILS',
      companyName: 'Company name',
      city: 'City',
      county: 'County',
      address: 'Address',
      phone: 'Phone',
      bankAccount: 'Bank account',
      bank: 'Bank',
      contactPerson: 'Contact person',
      save: 'Save',
      discountsSubheader: 'Discounts provided by Larexir Decor according to contract terms',
      discountsTitle: 'DISCOUNTS',
      marginSubheader: 'Markups over catalog price applied to final client',
      marginTitle: 'MARKUPS'
    },
    accountAddresses: {
      editTitle: 'Edit delivery address',
      addTitle: 'Add delivery address',
      locationName: 'Location name',
      postalCode: 'Postal code',
      notes: 'Notes',
      cancel: 'Cancel',
      save: 'Save',
      addButton: 'Add delivery address',
      updateError: 'Error: could not save changes. ({error})',
      updateSuccess: 'Delivery address changes saved successfully.',
      createError: 'Error: could not save delivery address. ({error})',
      createSuccess: 'Delivery address saved successfully.',
      listTitle: 'DELIVERY ADDRESSES',
      edit: 'Edit',
      delete: 'Delete',
      confirmDeleteTitle: 'Delete confirmation',
      confirmDeleteMessage: 'Are you sure you want to delete this delivery address from list?',
      deleteError: 'Error: could not delete delivery address. ({error})',
      deleteSuccess: 'Delivery address deleted successfully.',
      deleteCanceled: 'Delete operation was canceled.'
    },
    accountCommissioner: {
      subheader: 'List of final clients associated with commissioner.',
      title: 'COMMISSIONER FINAL CLIENTS',
      name: 'Name',
      city: 'City',
      county: 'County',
      address: 'Address',
      noClients: 'No clients associated with this commissioner.'
    },
    dashboard: {
      generalInfo: 'GENERAL INFO',
      welcome: 'Welcome to WebStore Larexir!',
      signInInfo: 'For sign in use the button: Sign in from left menu and enter credentials sent by us by email.',
      companyMessages: 'MESSAGES FOR COMPANY: {name}',
      resetTitle: 'WebStore Larexir - password reset!'
    },
    pdf: {
      common: {
        noRows: 'Order has no rows',
        obsPrefix: 'Obs.:',
        total: 'Total: {value} {currency}'
      },
      header: {
        taxCode: 'Tax code',
        tradeRegister: 'Trade reg.',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        offerTitle: 'OFFER {product}',
        orderTitle: 'ORDER {product}',
        number: 'Number',
        date: 'Date',
        status: 'Status',
        client: 'Client',
        observations: 'Notes',
        deliveryAddress: 'Delivery address'
      },
      footer: {
        lastUpdate: 'Last update/send: {date}'
      },
      content: {
        nrCrt: 'No.',
        tip: 'Type',
        tipRulou: 'Roller type',
        tipRoleta: 'Blind type',
        tipJaluzea: 'Venetian type',
        cod: 'Code',
        material: 'Material',
        lungime: 'Length',
        inaltime: 'Height',
        tipDesc: 'Open type',
        cod1: 'Code 1',
        cod2: 'Code 2',
        combCoduri: 'Code combo',
        lungimeSnurShort: 'Cord L.',
        tipConsole: 'Bracket type',
        nrConsole: 'No. brackets',
        optional: 'Optional',
        optional1: 'Optional 1',
        optional2: 'Optional 2',
        optional3: 'Optional 3',
        optional4: 'Optional 4',
        cant: 'Qty',
        pretLei: 'Price(RON)',
        pretEuro: 'Price(EUR)',
        lungimePanza: 'Fabric length',
        lungimeFinala: 'Final length',
        inaltimePanza: 'Fabric height',
        inaltimeFinala: 'Final height',
        actionare: 'Control',
        actionareShort: 'Ctrl.',
        tipActionare: 'Control type',
        ax: 'Shaft',
        culoareComp: 'Comp. color',
        culoareLamela: 'Slat color',
        culoareCaseta: 'Cassette color',
        culoare: 'Color',
        cota: 'Quota',
        fixare: 'Fixing',
        codCuloare: 'Color code',
        codCuloare2: 'Color code 2',
        lungimeBetisorActionare: 'Control stick length',
        clemePrindereMetal: 'Metal clamps',
        observatii: 'Notes'
      }
    },
    reports: {
      common: {
        onlySentOrders: 'The report contains only sent orders.',
        dateStart: 'Start date',
        dateEnd: 'End date',
        dateFormatPlaceholder: 'dd.mm.yyyy',
        periodRequired: 'Select report period.',
        invalidDateFormat: 'Invalid date format. Use dd.mm.yyyy.',
        startAfterEnd: 'Start date cannot be later than end date.',
        generateError: 'Error while generating report: {error}'
      },
      user: {
        cardTitle: 'ORDERS REPORT',
        pdfTitle: 'Orders report',
        companyPeriod: 'Company: {name} | Period: {start} - {end}',
        button: 'Orders report',
        filePrefix: 'orders-report',
        missingCompany: 'Could not identify user company.',
        productType: 'Product type: {type} ({currency})',
        totalByType: 'Total {type}',
        totalGeneral: 'Grand total',
        totalByCurrency: 'Total {currency}',
        columns: {
          productType: 'Product type',
          orderId: 'Order ID',
          date: 'Date',
          client: 'Client',
          orderValue: 'Order value',
          finalValue: 'Final value',
          notes: 'Notes'
        }
      },
      commissioner: {
        cardTitle: 'COMMISSIONER REPORT',
        pdfTitle: 'Commissioner report',
        companyPeriod: 'Commissioner: {name} | Period: {start} - {end}',
        productType: 'Product type: {type} ({currency})',
        button: 'Commissioner report',
        filePrefix: 'commissioner-report',
        noClients: 'No clients associated with this commissioner.',
        opInfo1: 'OP payments are detected by searching for OP (ex. OP, O.P., O P) in Notes.',
        opInfo2: 'This detection is not absolute and needs additional verification.',
        totalByType: 'Total {type}',
        totalOpByType: 'Total OP {type}',
        totalGeneral: 'Grand total',
        totalByCurrency: 'Total {currency}',
        totalOpByCurrency: 'Total OP {currency}',
        opMark: 'OP',
        columns: {
          productType: 'Product type',
          orderId: 'Order ID',
          date: 'Date',
          client: 'Client',
          catalogValue: 'Catalog value',
          finalValue: 'Final value',
          commissionerValue: 'Commissioner value',
          difference: 'Difference',
          notes: 'Notes',
          op: 'OP'
        }
      }
    }
  },
  bg: {
    common: {
      yes: 'Да',
      no: 'Не',
      loading: 'Зареждане ...',
      language: 'Език',
      romanian: 'Румънски',
      english: 'Английски',
      bulgarian: 'Български'
    },
    app: {
      loadingData: 'Данните се зареждат, моля изчакайте...'
    },
    sidebar: {
      home: 'Начало',
      products: 'Продукти',
      account: 'Моят профил',
      contact: 'Контакт',
      settings: 'Настройки',
      signOut: 'Изход',
      signIn: 'Вход',
      bnrTitle: 'КУРС БНБ'
    },
    signIn: {
      title: 'Вход',
      email: 'Имейл',
      password: 'Парола',
      submit: 'Вход',
      forgotPassword: 'Забравена парола?',
      requiredField: 'това поле е задължително',
      invalidEmailForReset: 'Моля, въведете имейла, използван при създаване на акаунта!',
      resetSuccess: 'Имейлът за смяна на парола беше изпратен успешно.',
      resetError: 'Грешка: неуспешно изпращане на имейл за смяна на парола. ({error})',
      loading: 'зареждане....'
    },
    account: {
      noAccess: 'Нямате права за достъп до: Моят профил!'
    },
    order: {
      noProductTypeSet: 'Не е зададен тип продукт',
      prefillClientPlaceholder: 'КЛИЕНТ ЗА ПОПЪЛВАНЕ',
      addLineTitle: 'Добави нов ред'
    },
    orderHeader: {
      title: 'ПОРЪЧКА {product} {status}',
      statusDefault: 'НЕИЗПРАТЕНА',
      statusSent: 'ИЗПРАТЕНА',
      pendingFirstSave: 'Номерът и датата се задават след първото запазване',
      sentSubheader: 'Номер: {id} от: {date} / дата на изпращане: {updatedAt}',
      updatedSubheader: 'Номер: {id} от: {date} / последна промяна: {updatedAt}',
      clientFinalTooltip: 'Краен клиент на дистрибутора.',
      clientFinalLabel: 'Краен клиент',
      clientFinalLocked: 'Крайният клиент не може да се променя след добавяне на първия ред.',
      selectClientFinal: 'Изберете краен клиент',
      clientFinalDetails: 'Данни за краен клиент',
      clientFinalDetailsValue: 'Маршрут: {ruta} | Град: {oras} | Адрес: {adresa} | Имейл: {email} | Телефон: {telefon} | Отстъпка {product}: {discount}%',
      measurementsAddressTooltip: 'Адрес, на който ще се извършат измервания от Larexir Decor.',
      measurementsAddressLabel: 'Адрес за измерване (вкл. телефон)',
      measurementsTypeTooltip: 'Тип продукт за измерване.',
      productTypeLabel: 'Тип продукт',
      expoAddressTooltip: 'Адрес, на който ще бъде доставен заявеният експозор.',
      expoAddressLabel: 'Адрес за доставка (вкл. телефон)',
      observationsLabel: 'Бележки'
    },
    orderFooter: {
      saveInProgress: 'Операция по запазване/изпращане вече е в ход.',
      hasChangesTitle: 'Поръчката има промени',
      hasChangesMessage: 'Сигурни ли сте, че искате да откажете тези промени?',
      cancelAbandon: 'Отказът е отменен.',
      selectFinalClient: 'Изберете краен клиент от списъка!',
      missingClient: 'Крайният клиент е задължителен!',
      missingDeliveryAddress: 'Адресът за доставка е задължителен!',
      saveSuccess: 'Успешно запазване',
      saveError: 'Грешка: неуспешно запазване на поръчката. ({error})',
      sendSuccess: 'Успешно изпращане',
      sendError: 'Грешка: неуспешно изпращане на поръчката. ({error})',
      sendConfirmTitle: 'Потвърждение за изпращане',
      sendConfirmMessage: 'След изпращане поръчката не може да бъде променяна и става окончателна. Сигурни ли сте, че искате да я изпратите?',
      sendCanceled: 'Изпращането е отменено.',
      send: 'Изпрати',
      save: 'Запази',
      cancel: 'Отказ'
    },
    orderLines: {
      add: 'Добави',
      edit: 'Промени',
      delete: 'Изтрий',
      update: 'Обнови',
      cancel: 'Отказ',
      save: 'Запази',
      columnId: 'ID ред',
      columnNo: '№',
      item: 'ред',
      items: 'редове',
      emptyRecord: 'Няма записи',
      editOperationAlert: 'Няма избран ред!',
      deleteOperationAlert: 'Няма избран ред!',
      saveButton: 'Запази',
      cancelButton: 'Отказ',
      confirmDelete: 'Сигурни ли сте, че искате да изтриете реда?',
      cancelEdit: 'Сигурни ли сте, че искате да откажете промените?',
      pagerCurrent: '{0} от {1} страници',
      pagerFirst: 'първа страница',
      pagerLast: 'последна страница',
      pagerNext: 'следваща страница',
      pagerPrevious: 'предишна страница',
      pagerTotal: '({0} записа)',
      addTooltip: 'Добави нов ред',
      editTooltip: 'Промени избрания ред',
      deleteTooltip: 'Изтрий избрания ред',
      transmittedReadOnly: 'Поръчката е изпратена - промени не са позволени',
      noClientBeforeAdd: 'Не може да добавяте редове преди да изберете краен клиент!',
      addTitle: 'Добави нов ред',
      editTitle: 'Промени ред',
      selectLineWarning: 'Моля, изберете ред',
      deleteConfirmTitle: 'Потвърждение за изтриване',
      deleteConfirmMessage: 'Сигурни ли сте, че искате да изтриете реда?',
      deleteCanceled: 'Изтриването е отменено.',
      addSuccess: 'Редът е добавен успешно',
      editSuccess: 'Редът е променен успешно',
      deleteSuccess: 'Редът е изтрит успешно'
    },
    orderLineEdit: {
      validationError: 'Въведените стойности не отговарят на правилата за валидация. Записът не може да бъде запазен.',
      save: 'Запази',
      cancel: 'Отказ',
      clientPriceEditableNote: '*)полето за клиентска цена може да се редактира'
    },
    orderLineForm: {
      typeBlind: 'Тип щора',
      typePleatedBlind: 'Тип плисирана щора',
      typeVenetian: 'Тип венецианска щора',
      typeRoller: 'Тип роло',
      typeGarageDoor: 'Тип гаражна врата',
      material: 'Материал',
      code: 'Код',
      code1: 'Код 1',
      code2: 'Код 2',
      color: 'Цвят',
      colorSlats: 'Цвят ламели',
      colorCassette: 'Цвят кутия',
      meshType: 'Тип мрежа',
      partialMesh: 'Съдържа частична мрежа',
      width: 'Ширина',
      widthRail: 'Ширина(корниз)',
      widthFabric: 'Ширина ПЛАТ',
      widthFinal: 'Крайна ширина',
      height: 'Височина',
      heightFabric: 'Височина ПЛАТ',
      heightFinal: 'Крайна височина',
      openingType: 'Тип отваряне',
      actionType: 'Тип управление',
      quota: 'Кота',
      quotaFinalGol: 'Кота (крайна/отвор)',
      action: 'Управление',
      axis: 'Ос',
      colorComponents: 'Цвят компоненти',
      colorComponentsLegacy: 'Цвят комп. стар *)',
      colorCode: 'Цветови код',
      colorCode2: 'Цветови код 2',
      fixingGuideDownFix: 'Фиксиране (Guide/DownFix)',
      stickLengthShort: 'Дълж. пръчка',
      metalClampsShort: 'Мет. скоби',
      option1: 'Опция 1',
      option2: 'Опция 2',
      option3: 'Опция 3',
      option4: 'Опция 4',
      optional: 'Опция',
      codeCombination: 'Описание комбинация кодове(стар цветови код)',
      cordLength: 'Дължина шнур',
      consoleType: 'Тип конзоли',
      consoleCount: 'Брой конзоли',
      notes: 'Бележки',
      quantity: 'Количество',
      tPrefix: 'T',
      left: 'Ляво',
      right: 'Дясно',
      small: 'МАЛЪК',
      large: 'ГОЛЯМ',
      axis32mm: '32 мм',
      cartsPerPiece: 'Плъзгачи/бр.',
      mpPerPiece: 'кв.м/бр.',
      totalMp: 'ОБЩО кв.м',
      catalogPrice: 'Каталожна цена',
      commissionerPrice: 'Цена комисионер',
      orderPrice: 'Цена поръчка',
      clientPrice: 'Цена клиент',
      unitMm: 'мм',
      unitCons: 'бр.',
      unitPieces: 'бр.',
      unitMp: 'кв.м',
      unitLei: 'леи',
      openingWarningPrefix: 'Тип отваряне: {value} - {message}',
      openingHint1: 'Избрали сте управление, при което ламелите се събират от страната на шнура (ляво или дясно).',
      openingHint2: 'Избрали сте управление, при което ламелите се събират в противоположната страна на шнура (ляво или дясно).',
      openingHint3: 'Избрали сте управление тип завеса ляво-дясно (половината вляво и половината вдясно).',
      openingHint4: 'Избрали сте обратно управление тип завеса (всички ламели се събират в средата).',
      openingHintL: 'Изпълнение само на ламели без корниз (въведете броя ламели в полето Ширина, напр. 23).',
      openingHintDA: 'Изпълнение с двойно управление (шнур от двете страни). Допълнителна цена: 40 леи/бр.',
      consoleDefaultWarning: 'Ако не попълните типа конзоли, ще се приемат фиксирани конзоли.',
      codeWarningPrefix: 'Съобщение за код:{code}: {message}',
      partialMeshSingleWarning: 'Внимание! Редовете с частична мрежа се въвеждат поотделно (Количество=1), следвани от следващ ред с частична мрежа.',
      partialMeshFollowWarning: 'Внимание! Ред с частична мрежа трябва да бъде последван от следващ ред с частична мрежа.',
      priceZeroTooLarge: 'Цена 0 за въведените размери. Размерите са твърде големи за избрания продукт.',
      jvHeightNote: 'Внимание! Височината трябва да включва и дебелината на корниза, включително при поръчки само с ламели. (Тип отваряне: L)',
      jviMinBillableHeight: 'Внимание! МИНИМАЛНАТА ФАКТУРИРУЕМА ВИСОЧИНА Е 2000 мм !!!'
    },
    ordersFooter: {
      productsMenu: 'Меню продукти',
      offerPdf: 'Оферта pdf',
      orderPdf: 'Поръчка pdf',
      selectOrderWarning: 'Моля, изберете поръчка.'
    },
    ordersTable: {
      add: 'Добави',
      edit: 'Промени',
      delete: 'Изтрий',
      update: 'Обнови',
      cancel: 'Отказ',
      save: 'Запази',
      item: 'поръчка',
      items: 'поръчки',
      emptyRecord: 'Няма записи',
      noOrderSelected: 'Няма избрана поръчка.',
      colSelect: 'ИЗБОР',
      colOrderNo: '№ ПОРЪЧКА',
      colDate: 'ДАТА',
      colClient: 'КЛИЕНТ',
      colOrderValue: 'СТОЙНОСТ ПОРЪЧКА',
      colFinalValue: 'СТОЙНОСТ КРАЕН КЛИЕНТ',
      colStatus: 'СТАТУС'
    },
    ordersList: {
      exchangeRateNotice: 'Внимание! Курсът за продукти в евро е БНБ + 1% към датата на обработка.',
      workScheduleNotice: 'Поръчките се обработват в работно време (Пон-Пет 09:00-17:00, без официални празници).',
      quoteFluctuationNotice: 'Моля, имайте предвид възможни колебания на курса при офериране към краен клиент.'
    },
    productCard: {
      menuPresentation: 'Представяне',
      menuPrices: 'Цени',
      menuMeasureInstall: 'Измерване и монтаж',
      menuVideo: 'Видео',
      menuRequestDisplay: 'Заяви експозор',
      loadingOrders: 'Поръчките се зареждат...',
      orderProcessError: 'Възникна грешка при обработка на поръчката.'
    },
    productList: {
      pagination: '1-6 от 20'
    },
    expozor: {
      headerTitle: 'ЕКСПОЗОРИ (в процес)',
      search: 'Търси:'
    },
    video: {
      headerTitle: 'ВИДЕО (в процес)',
      allCategories: 'Всички категории',
      searchLabel: 'Търси',
      boardCategories: 'Категории',
      boardVideo: 'Видео',
      closePlayer: 'Затвори видео плейъра'
    },
    contact: {
      formTitle: 'КОНТАКТНА ФОРМА',
      email: 'Имейл',
      subject: 'Тема',
      message: 'Съобщение',
      submit: 'ИЗПРАТИ',
      sendSuccess: 'Съобщението е изпратено успешно.',
      companyTitle: 'КОНТАКТНИ ДАННИ'
    },
    settings: {
      noAccess: 'Нямате права за достъп до: Настройки!',
      resetPasswordTitle: 'Смяна на парола',
      resetPasswordButton: 'ИЗПРАТИ ЛИНК ЗА СМЯНА НА ПАРОЛА'
    },
    resetPassword: {
      pageTitle: 'WebStore Larexir - смяна на парола!',
      newPasswordTitle: 'Нова парола',
      submit: 'РЕСЕТ'
    },
    notFound: {
      title: '404: Страницата, която търсите, не съществува.',
      subtitle: 'За връщане към началната страница натиснете логото горе вляво.'
    },
    accountDetails: {
      companyTitle: 'ДАННИ НА ФИРМА',
      save: 'Запази'
    },
    accountAddresses: {
      listTitle: 'АДРЕСИ ЗА ДОСТАВКА',
      addButton: 'Добави адрес за доставка'
    },
    accountCommissioner: {
      title: 'КРАЙНИ КЛИЕНТИ НА КОМИСИОНЕР'
    },
    dashboard: {
      generalInfo: 'ОБЩА ИНФОРМАЦИЯ',
      welcome: 'Добре дошли в WebStore Larexir!',
      companyMessages: 'СЪОБЩЕНИЯ ЗА ФИРМА: {name}'
    },
    pdf: {
      common: {
        noRows: 'Поръчката няма редове',
        obsPrefix: 'Бел.:',
        total: 'Общо: {value} {currency}'
      },
      header: {
        taxCode: 'Данъчен номер',
        tradeRegister: 'Търг. рег.',
        address: 'Адрес',
        phone: 'Телефон',
        email: 'Имейл',
        offerTitle: 'ОФЕРТА {product}',
        orderTitle: 'ПОРЪЧКА {product}',
        number: 'Номер',
        date: 'Дата',
        status: 'Статус',
        client: 'Клиент',
        observations: 'Бележки',
        deliveryAddress: 'Адрес за доставка'
      },
      footer: {
        lastUpdate: 'Последна промяна/изпращане: {date}'
      },
      content: {
        nrCrt: '№',
        tip: 'Тип',
        tipRulou: 'Тип роло',
        tipRoleta: 'Тип щора',
        tipJaluzea: 'Тип щора',
        cod: 'Код',
        material: 'Материал',
        lungime: 'Дължина',
        inaltime: 'Височина',
        tipDesc: 'Тип отваряне',
        cod1: 'Код 1',
        cod2: 'Код 2',
        combCoduri: 'Комб. кодове',
        lungimeSnurShort: 'Шнур',
        tipConsole: 'Тип конзоли',
        nrConsole: 'Бр. конзоли',
        optional: 'Опция',
        optional1: 'Опция 1',
        optional2: 'Опция 2',
        optional3: 'Опция 3',
        optional4: 'Опция 4',
        cant: 'Кол.',
        pretLei: 'Цена(леи)',
        pretEuro: 'Цена(евро)',
        lungimePanza: 'Дължина ПЛАТ',
        lungimeFinala: 'Крайна дължина',
        inaltimePanza: 'Височина ПЛАТ',
        inaltimeFinala: 'Крайна височина',
        actionare: 'Управление',
        actionareShort: 'Упр.',
        tipActionare: 'Тип управление',
        ax: 'Ос',
        culoareComp: 'Цвят комп.',
        culoareLamela: 'Цвят ламели',
        culoareCaseta: 'Цвят кутия',
        culoare: 'Цвят',
        cota: 'Кота',
        fixare: 'Фиксиране',
        codCuloare: 'Цветови код',
        codCuloare2: 'Цветови код 2',
        lungimeBetisorActionare: 'Дължина пръчка',
        clemePrindereMetal: 'Метални скоби',
        observatii: 'Бележки'
      }
    },
    reports: {
      common: {
        onlySentOrders: 'Отчетът съдържа само изпратени поръчки.',
        dateStart: 'Начална дата',
        dateEnd: 'Крайна дата',
        dateFormatPlaceholder: 'dd.mm.yyyy',
        periodRequired: 'Изберете период за отчета.',
        invalidDateFormat: 'Невалиден формат на дата. Използвайте dd.mm.yyyy.',
        startAfterEnd: 'Началната дата не може да е след крайната.',
        generateError: 'Грешка при генериране на отчет: {error}'
      },
      user: {
        cardTitle: 'ОТЧЕТ ПОРЪЧКИ',
        pdfTitle: 'Отчет поръчки',
        companyPeriod: 'Фирма: {name} | Период: {start} - {end}',
        button: 'Отчет поръчки',
        filePrefix: 'otchet-porachki',
        missingCompany: 'Не успяхме да идентифицираме фирмата на потребителя.',
        productType: 'Тип продукт: {type} ({currency})',
        totalByType: 'Общо {type}',
        totalGeneral: 'Общо',
        totalByCurrency: 'Общо {currency}',
        columns: {
          productType: 'Тип продукт',
          orderId: 'ID поръчка',
          date: 'Дата',
          client: 'Клиент',
          orderValue: 'Стойн. поръчка',
          finalValue: 'Стойн. краен клиент',
          notes: 'Бел.'
        }
      },
      commissioner: {
        cardTitle: 'ОТЧЕТ КОМИСИОНЕР',
        pdfTitle: 'Отчет комисионер',
        companyPeriod: 'Комисионер: {name} | Период: {start} - {end}',
        productType: 'Тип продукт: {type} ({currency})',
        button: 'Отчет комисионер',
        filePrefix: 'otchet-komisioner',
        noClients: 'Няма клиенти, свързани с този комисионер.',
        opInfo1: 'Плащанията с OP се откриват чрез търсене на OP (напр. OP, O.P., O P) в Бележки.',
        opInfo2: 'Това определяне не е абсолютно и изисква допълнителна проверка.',
        totalByType: 'Общо {type}',
        totalOpByType: 'Общо OP {type}',
        totalGeneral: 'Общо',
        totalByCurrency: 'Общо {currency}',
        totalOpByCurrency: 'Общо OP {currency}',
        opMark: 'OP',
        columns: {
          productType: 'Тип продукт',
          orderId: 'ID поръчка',
          date: 'Дата',
          client: 'Клиент',
          catalogValue: 'Каталожна стойн.',
          finalValue: 'Стойн. краен клиент',
          commissionerValue: 'Стойн. комисионер',
          difference: 'Разлика',
          notes: 'Бел.',
          op: 'OP'
        }
      }
    }
  }
};
